import React from "react"
import { InputTextarea } from "primereact/inputtextarea"
import { Field } from "formik"

import styles from "../../styles/Form.module.css"

export default function TypeTextarea(props) {
  const { fieldname, label } = props
  return (
    <Field name={fieldname}>
      {({ field, meta }) => {
        return (
          <div className={styles.field}>
            <label htmlFor={fieldname} className={styles.label}>
              {label}
            </label>
            <InputTextarea
              id={fieldname}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
            {meta.touched && meta.error && (
              <div className={styles.error}>{meta.error}</div>
            )}
          </div>
        )
      }}
    </Field>
  )
}
